import config from '@epi-config';

export const crossSellingOrderApiUrl = `${config.apiHost}/api/cross-selling/order`;
